import axios, { AxiosResponse } from "axios";

export const agentService = {
  getLogo: (agentCode: string): Promise<AxiosResponse<any>> => {
    return axios.get<any>(`/agent/${agentCode}`, {
      headers: { "content-type": "application/json" }
    });
  }
};
